import FieldsConstants from 'src/app/common/fields.constants';
import ProjectLinks from 'src/app/common/project.links';
import FieldAllowedAttributeTypes from 'src/app/forms/fields/field-allowed-attribute-types.values';
import FieldAllowedValueClasses from 'src/app/forms/fields/field-allowed-value-classes.values';
import { FormTypes } from 'src/app/forms/forms.enum';
import { Attribute } from 'src/app/interfaces/form-and-field.interface';
import { CommunityBasic } from 'src/app/swagger-api';
import { projectLinkedCommunitiesMetadata } from './community-mock.data';

export const entityBasedCommunityLink = <T extends CommunityBasic>(community: T) => {
  const route = community.focus === 'CHARITY' ? ProjectLinks.LINK_CHARITY_VIEW : ProjectLinks.LINK_COMMUNITY_VIEW;

  return `${route}/${community.entity_id}`;
};

export const SPECIALTIES_FIELD: Attribute = {
  name: 'specialities',
  value_class_front: FieldAllowedValueClasses.SPECIALTIES_SELECT,
  min_length: 1,
  max_length: 2000,
  type_attribute: FieldAllowedAttributeTypes.MULTIPLE_CUSTOM_SELECT,
  required: true,
  read_only: false,
  label: 'FORM_CONSTRUCTOR_COMMUNITY_SPECIALTIES_LABEL',
  placeholder: 'FORM_CONSTRUCTOR_COMMUNITY_SPECIALTIES_PLACEHOLDER',
  security: false,
  scheme_name: FormTypes.COMMUNITY,
};

export const DISEASES_FILED: Attribute = {
  name: 'diseases',
  value_class_front: FieldAllowedValueClasses.DISEASES_SELECT,
  min_length: 1,
  max_length: 2000,
  type_attribute: FieldAllowedAttributeTypes.MULTIPLE_CUSTOM_SELECT,
  required: true,
  read_only: false,
  label: 'FORM_CONSTRUCTOR_COMMUNITY_DISEASES_LABEL',
  placeholder: 'FORM_CONSTRUCTOR_COMMUNITY_DISEASES_PLACEHOLDER',
  security: false,
  scheme_name: FormTypes.COMMUNITY,
};

export const CHARITY_FOCUSES_FILED: Attribute = {
  name: 'charity_focuses',
  value_class_front: FieldAllowedValueClasses.CHARITY_FOCUSES,
  min_length: 1,
  max_length: 2000,
  type_attribute: FieldAllowedAttributeTypes.MULTIPLE_CUSTOM_SELECT,
  required: true,
  read_only: false,
  label: 'FORM_CONSTRUCTOR_COMMUNITY_CHARITY_FOCUSES_LABEL',
  placeholder: 'FORM_CONSTRUCTOR_COMMUNITY_CHARITY_FOCUSES_PLACEHOLDER',
  security: false,
  scheme_name: FormTypes.COMMUNITY,
};

export const COMMUNITY_FOCUS_FIELDS_ATTRIBUTES = {
  name: 'focus',
  value_class_front: FieldAllowedValueClasses.FOCUS,
  min_length: 0,
  max_length: 0,
  type_attribute: FieldAllowedAttributeTypes.FOCUS,
  required: true,
  read_only: false,
  label: '',
  placeholder: '',
  security: false,
  scheme_name: FormTypes.COMMUNITY,
};

export const COMMUNITY_FORM_FIELDS_ATTRIBUTES: Attribute[] = [
  COMMUNITY_FOCUS_FIELDS_ATTRIBUTES,
  {
    name: 'title',
    value_class_front: FieldAllowedValueClasses.CHARACTERS,
    min_length: 1,
    max_length: 50,
    type_attribute: FieldAllowedAttributeTypes.TEXT,
    required: true,
    read_only: false,
    label: 'Community Name',
    placeholder: 'Enter community name',
    security: false,
    scheme_name: FormTypes.COMMUNITY,
  },
  {
    name: 'description',
    value_class_front: FieldAllowedValueClasses.TEXTAREA_FULL,
    min_length: 1,
    max_length: 1000,
    type_attribute: FieldAllowedAttributeTypes.TEXTAREA,
    required: true,
    read_only: false,
    label: 'Community Description',
    placeholder: 'Enter community description',
    security: false,
    scheme_name: FormTypes.COMMUNITY,
  },
  {
    name: 'website',
    value_class_front: FieldAllowedValueClasses.URL,
    min_length: FieldsConstants.MIN_WEBSITE_LINK_LENGTH,
    max_length: FieldsConstants.MAX_WEBSITE_LINK_LENGTH,
    type_attribute: FieldAllowedAttributeTypes.TEXT,
    required: false,
    read_only: false,
    label: 'Community Website',
    placeholder: 'Enter valid website address',
    security: false,
    scheme_name: FormTypes.COMMUNITY,
  },
  {
    name: 'type',
    value_class_front: FieldAllowedValueClasses.CHARACTERS,
    min_length: 1,
    max_length: 50,
    type_attribute: FieldAllowedAttributeTypes.TEXT,
    required: true,
    read_only: false,
    label: 'Community Type',
    placeholder: 'Enter community type',
    security: true,
    scheme_name: FormTypes.COMMUNITY,
  },
  SPECIALTIES_FIELD,
  DISEASES_FILED,
  CHARITY_FOCUSES_FILED,
  {
    name: 'location',
    value_class_front: FieldAllowedValueClasses.CITY_LEVEL_LOCATION,
    min_length: 1,
    max_length: 50,
    type_attribute: FieldAllowedAttributeTypes.TEXT,
    required: true,
    read_only: false,
    label: 'City Location',
    placeholder: 'Type to select community location',
    security: false,
    scheme_name: FormTypes.COMMUNITY,
  },
  {
    name: 'viewport',
    value_class_front: FieldAllowedValueClasses.VIEWPORT,
    min_length: 1,
    max_length: 50,
    type_attribute: FieldAllowedAttributeTypes.TEXT,
    required: false,
    read_only: true,
    label: 'Viewport',
    placeholder: 'Automatically by viewport',
    security: false,
    scheme_name: FormTypes.COMMUNITY,
  },
  {
    name: 'status',
    value_class_front: FieldAllowedValueClasses.IS_OPEN_SELECT,
    min_length: 1,
    max_length: 10,
    type_attribute: FieldAllowedAttributeTypes.SELECT,
    required: true,
    read_only: false,
    label: 'Community Permission Settings',
    placeholder: 'Select Public or Private',
    security: false,
    scheme_name: FormTypes.COMMUNITY,
  },
  projectLinkedCommunitiesMetadata,
];
